import {cloneDeep, get} from "lodash";
import {getString} from "Core/helpers/data";
import {UserSubmittedQuestionnairesListItemDataObject} from "../dataObjects";
import {getDate, STANDARD_DATE_TIME_FORMAT} from "Core/helpers/datetime";
import {PATIENT_GENDER_GENDER_MAP} from '../../../../pages/apps/default/studies/const';

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {UserSubmittedQuestionnairesListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new UserSubmittedQuestionnairesListItemDataObject(
		getString(result, 'id'),
		getString(result, 'firstName'),
		getString(result, 'lastName'),
		getDate(get(result, 'dateOfBirth', null), STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S),
		getDate(get(result, 'dateQuestionnaireSubmitted', null), STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S),
		get(result, 'gender', null) === null ? null : getString(PATIENT_GENDER_GENDER_MAP, getString(result, 'gender')),
	);

	return result;
}

// @note: There is no output function since list is read-only.